// extracted by mini-css-extract-plugin
export default {"buttonContainer":"FeedbackForm_buttonContainer__ZSSmy","button":"FeedbackForm_button__1Q42O","ErrorText":"FeedbackForm_ErrorText__TMK2z"};